const BoxList = () => import('Views/box/box-list');
const BoxAddEdit = () => import('Views/box/box-addEdit');
const BoxDetail = () => import('Views/box/box-detail');
const BoxMaintenance = () => import('Views/box/box-maintenance');
const BoxMaintenanceAdd = () => import('Views/box/box-maintenance-add');
const BoxMaintenanceDetail = () => import('Views/box/box-maintenance-detail');

export default [
  { path: '/box-list', component: BoxList },
  { path: '/box-add', component: BoxAddEdit },
  { path: '/box-edit/:id', component: BoxAddEdit },
  { path: '/box-detail/:id', component: BoxDetail },
  { path: '/box-maintenance', component: BoxMaintenance },
  { path: '/box-maintenance-add', component: BoxMaintenanceAdd },
  { path: '/box-maintenance-detail/:id', component: BoxMaintenanceDetail },
];



// WEBPACK FOOTER //
// ./src/router/box.js